import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    List,
    ListItem,
    Container,
} from "@mui/material";

function ContentManagement() {
    const [content, setContent] = useState([]);

    useEffect(() => {
        axios({
            method: "GET",
            url: "/files/webApplication/content_management.txt",
        }).then((res) => {
            setContent(res.data);
        });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            <Box id="contentmanagement" sx={{ mt: 8, mb: 6 }}>
                {/* Title */}
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem",  // mobile (~h4)
                            sm: "2.2rem",  // tablet (~h3)
                            md: "2.8rem",  // laptop (~h3+)
                            lg: "3rem",    // desktop (~h2)
                        },
                    }}
                >
                    Content Management System
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", mt: 4 }}>
                    {content &&
                        content.map((data, index) => (
                            <Box key={index} sx={{ mb: 3, textAlign: "justify" }}>
                                {Array.isArray(data) ? (
                                    <Box>
                                        <Typography
                                            variant="h6"
                                            sx={{ color: "#030366", mb: 1, fontWeight: 600 }}
                                        >
                                            In addition to the Content Management System, we also offer the
                                            following services to our clients:
                                        </Typography>
                                        <List>
                                            {data.map((subItem, subIndex) => (
                                                <ListItem
                                                    key={subIndex}
                                                    sx={{
                                                        fontFamily: "Raleway, sans-serif",
                                                        display: "list-item",
                                                        pl: 2,
                                                    }}
                                                >
                                                    {subItem}
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        sx={{ fontFamily: "Raleway, sans-serif" }}
                                    >
                                        {data}
                                    </Typography>
                                )}
                            </Box>
                        ))}
                </Box>
            </Box>
        </Container>
    );
}

export default ContentManagement;
